import React from "react";
import { RemoveIcon } from "../../assets/icons";
import { POLLS_REMOVE_ANSWER_BUTTON } from "../../dataHooks";
import styles from "./option-scss";
const RemoveOption = ({ onClick }) => {
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      "data-hook": POLLS_REMOVE_ANSWER_BUTTON,
      onClick,
      className: styles.removeButton
    },
    /* @__PURE__ */ React.createElement(RemoveIcon, { className: styles.removeButtonIcon })
  );
};
export {
  RemoveOption
};
//# sourceMappingURL=RemoveOption.js.map
